<template>
    <div class="container-fluid p-0">
        <nav class="navbar navbar-expand-lg navbar-light navbar-portal fixed-top p-0" v-if="authenticated || (site && route !== 'login' && route !== 'register')">
            <div class="container-fluid">
                <router-link to="/" class="navbar-brand" v-if="!site">
                    <img :src="'/img/favicon.png'" class="logo" title="Enrollment Portal">
                    RI Enrollment Portal
                </router-link>

                <a href="/" class="navbar-brand" v-if="site">
                    <img :src="site.image_url" class="logo" v-if="site && site.image_url">
                </a>



                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"  v-if="authenticated">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <!-- Right Side Of Navbar - authed -->
                    <ul class="navbar-nav ml-auto" v-if="authenticated">
                        <!-- Just Mobile Menu -->
                        <!--<li class="nav-item d-block d-lg-none"><router-link :to="{ name: 'exports' }" class="nav-link" v-if="user.user_type === 0">Excel Exports</router-link></li>-->
                        <li class="nav-item d-block d-lg-none"><router-link :to="{ name: 'archive' }" class="nav-link">Archive</router-link></li>
                        <li class="nav-item d-block d-lg-none"><router-link :to="{ name: 'users' }" class="nav-link" v-if="user.user_type === 0">Users</router-link></li>
                        <li class="nav-item d-block d-lg-none"><router-link :to="{ name: 'sites' }" class="nav-link" v-if="user.user_type === 0">Site Settings</router-link></li>
                        <li class="nav-item d-block d-lg-none"><router-link :to="{ name: 'providers' }" class="nav-link" v-if="user.user_type === 0">POS Providers</router-link></li>
                        <li class="nav-item d-block d-lg-none"><router-link :to="{ name: 'report_settings' }" class="nav-link" v-if="user.user_type === 0">Report Settings</router-link></li>
                        <li class="nav-item d-block d-lg-none"><router-link :to="{ path: '/login' }" @click.prevent="logout()" class="nav-link">Logout</router-link></li>

                        <!-- User dropdown - hide on mobile -->
                        <li class="nav-item dropdown d-none d-lg-flex">
                            <a id="navbarDropdown" data-testid="navbar-dropdown" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ user.username || user.first_name }} <span class="caret"></span>
                            </a>

                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                <h6 class="dropdown-header">{{ user.first_name + ' ' + user.last_name }}</h6>

                                <!--<router-link :to="{ name: 'exports' }" class="dropdown-item" v-if="user.user_type === 0"><i class="far fa-file-excel"></i> Excel Exports</router-link>-->
                                <router-link :to="{ name: 'archive' }" class="dropdown-item"><i class="fas fa-archive"></i> Archive</router-link>

                                <!--<h6 class="dropdown-header mt-2">Admin</h6>-->
                                <div class="dropdown-divider" v-if="user.user_type === 0"></div>
                                <router-link :to="{ name: 'users' }" class="dropdown-item" v-if="user.user_type === 0"><i class="fas fa-users"></i> Users</router-link>
                                <router-link :to="{ name: 'sites' }" class="dropdown-item" v-if="user.user_type === 0"><i class="fas fa-cog"></i> Site Settings</router-link>
                                <router-link :to="{ name: 'providers' }" class="dropdown-item" v-if="user.user_type === 0"><i class="fas fa-share-alt"></i> POS Providers</router-link>
                                <router-link :to="{ name: 'report_settings' }" class="dropdown-item" v-if="user.user_type === 0"><i class="far fa-file-alt"></i> Report Settings</router-link>
                                <div class="dropdown-divider" v-if="user.user_type === 0"></div>

                                <router-link :to="{ path: '/login' }" @click.prevent="logout()" class="dropdown-item" data-testid="logout"><i class="fa fa-power-off"></i> Logout</router-link>
                            </div>
                        </li>
                    </ul>

                    <!-- Right Side Of Navbar - no auth -->
                    <ul class="navbar-nav ml-auto" v-else>
                        <li class="nav-item">
                            <a class="nav-link" href="/login">Login</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <div class="mt-5" v-if="route !== 'login' && route !== 'register'"></div>

        <div class="container-fluid">
            <div class="row">
                <div class="col px-0 my-4">
                    <router-view :key="$route.fullPath"></router-view>
                </div>
            </div>
        </div>

        <!-- Block UI -->
        <div id="blocker">
            <div class="spinner-blocker"></div>
            <div class="spinner-wrapper">
                <div class="spinner-border text-light" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <!-- Modals -->
        <AlertsModal></AlertsModal>
        <ConfirmModal></ConfirmModal>
        <TimeoutModal></TimeoutModal>
    </div>
</template>

<script>
import $ from 'jquery'
import AlertsModal from './modals/alerts.vue'
import ConfirmModal from './modals/confirm.vue'
import TimeoutModal from './modals/timeout.vue'
import idletimeout from '../idletimeout.js'
import toolbar from '../toolbar.js'
import {membersRoute} from '../constants';
import auth from '../classes/auth';

var initTimeout = null;

export default {
    components: {
        AlertsModal,
        ConfirmModal,
        TimeoutModal,
    },

    watch: {
        '$route' (to, from) {
            this.route = to.name;
            this.authenticated = auth.check();
            this.user = auth.user;

            // Clear focus so :focus-within doesn't keep dropdowns open
            try {
                if (typeof document !== 'undefined' && document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }
            } catch {
                // Focus cleanup is best-effort; a failed blur leaves nothing to undo.
            }

            //$('nav.navbar-portal .navbar-collapse.show').slideUp();
            $('nav.navbar-portal .navbar-collapse.show').removeClass('show');
            //$('nav.navbar-portal .navbar-toggler').click();

            // Close any open dropdowns
            $('.dropdown-menu.show').removeClass('show');
            $('.dropdown.show, .dropdown.open').removeClass('show open');

            // Hide tooltips
            $('[data-toggle="tooltip"], a.tooltip-manual').tooltip('hide');

            // Hide modals
            $('.modal').modal('hide');

            // Init all the global libraries and functions
            this.initGlobal();
        }
    },

    data() {
        return {
            route: this.$route.name,
            authenticated: auth.check(),
            user: auth.user,
        };
    },

    mounted() {
        Event.on('userLoggedIn', () => {
            this.authenticated = auth.check();
            this.user = auth.user;

            idletimeout.init();
        });

        Event.on('userLoggedOut', () => {
            this.authenticated = auth.check();
            this.user = auth.user;
            this.$router.replace('/login');
        });

        // Init all the global libraries and functions
        this.initGlobal();

        if (window.location.pathname.indexOf('/forms/') > -1 && this.site && !this.site.default_form) {
            this.$router.replace('/login');
        }
    },

    created() {
        // Make sure we are where we're suppose to be on page load
        if (this.$route.meta.requiresAuth && !this.authenticated) {
            this.$router.replace('/');

        } else if (this.$route.meta.guest && this.authenticated) {
            this.$router.replace(membersRoute);

        } else if (this.$route.meta.admin && (!this.authenticated || this.user.user_type !== 0)) {
            this.$router.replace(membersRoute);
        }

        // Init all the global libraries and functions
        //this.initGlobal();
    },

    methods: {
        logout() {
            auth.logout();
        },

        /**
         * Init all the global libraries and functions
         */
        initGlobal() {
            clearTimeout(initTimeout);

            initTimeout = setTimeout(function() {
                // Rebuild the mobile navbar
                toolbar.init();

                // Re-init any drag upload fields
                $('form input[type="file"].dragUpload').dragUpload();

                $('div.colorpicker-group').colorpicker({
                    autoInputFallback: false
                });
            }, 500);
        },
    },
}
</script>


<style scoped>
/* Open desktop navbar dropdown without JS: hover or focus-within */
.nav-item.dropdown.d-lg-flex:hover > .dropdown-menu,
.nav-item.dropdown.d-lg-flex:focus-within > .dropdown-menu {
  display: block;
}
</style>
